import {
  InvoiceTaxType,
  InvoiceExigibility,
} from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.types';

export const issTaxTypeOptions = [
  {
    value: InvoiceTaxType.EXEMPT_ISS,
    label: 'Isento de ISS',
  },
  {
    value: InvoiceTaxType.IMMUNE,
    label: 'Imune',
  },
  {
    value: InvoiceTaxType.NON_INCIDENCE_IN_CITY,
    label: 'Não incidência no município',
  },
  {
    value: InvoiceTaxType.NON_TAXABLE,
    label: 'Não tributável',
  },
  {
    value: InvoiceTaxType.WITHHELD,
    label: 'Retido',
  },
  {
    value: InvoiceTaxType.TAXABLE_WITHIN_CITY,
    label: 'Tributável dentro do município',
  },
  {
    value: InvoiceTaxType.TAXABLE_OUTSIDE_CITY,
    label: 'Tributável fora do município',
  },
  {
    value: InvoiceTaxType.TAXABLE_WITHIN_CITY_BY_TAKER,
    label: 'Tributável dentro do município pelo comprador',
  },
];

export const issExigibilityOptions = [
  {
    value: InvoiceExigibility.EXIGIBLE,
    label: 'Exigível',
  },
  {
    value: InvoiceExigibility.NON_INCIDENCE,
    label: 'Não incidência',
  },
  {
    value: InvoiceExigibility.EXEMPTION,
    label: 'Isenção',
  },
  {
    value: InvoiceExigibility.EXPORT,
    label: 'Exportação',
  },
  {
    value: InvoiceExigibility.IMMUNITY,
    label: 'Imunidade',
  },
  {
    value: InvoiceExigibility.JUDICIAL_SUSPENSION,
    label: 'Suspenso por ação judicial',
  },
  {
    value: InvoiceExigibility.ADMINISTRATIVE_SUSPENSION,
    label: 'Suspenso por ação administrativa',
  },
];
